import type { RequestConfig } from '@customTypes/index';
import type { VideoItemDto } from '@customTypes/types';

import { api } from '@/shared/api/instance';

export type GetClubProfileVideoListRequest = {
  profileId: string;
};

export type GetClubProfileVideoListParams =
  RequestConfig<GetClubProfileVideoListRequest>;

export const getClubProfileVideoList = async ({
  params,
  config
}: GetClubProfileVideoListParams) =>
  api.get<VideoItemDto[]>(`/api/videos/club/${params.profileId}`, config);
